import { useEffect } from 'react';
import { paths } from '@common/types';
import { postRequest } from '@config/axios/axios.config';
import { useNavigate, useSearchParams } from 'react-router-dom';

// An intermediary step in the login process. The link from the email
// sends the user here, then the token is re-fetched, then the user
// is sent to the MFA login page.
export const LoginStepEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const goToLoginWithError = () => {
    navigate('/auth/login', { state: { invalidToken: true } });
  };

  if (!token) {
    goToLoginWithError();
  }

  const loginEmailTokenRequest = async () => {
    try {
      const response = await postRequest<
        paths['/auth/login/email']['post']['requestBody']['content']['application/json'],
        paths['/auth/login/email']['post']['responses']['200']['content']['application/json']
      >('/auth/login/email', {
        token,
      });
      navigate(`/auth/login/mfa?token=${response.data.token}`, {
        state: {
          mfaType: response.data.mfa_type,
          maskedPhoneNumber: response.data?.mfa_phone_number,
        },
      });
    } catch {
      goToLoginWithError();
    }
  };

  useEffect(() => {
    loginEmailTokenRequest();
  }, []);

  return <></>;
};
